import { Routes, Route, useNavigate } from "react-router-dom";
import { Container, Fade, Box } from "@mui/material";
import AppBar from "../components/AppBar"
import { ViewAnswersPage } from "./ViewAnswersPage";
import { AnswerSentimentAndKeyword } from "./AnswerSentimentAndKeyword";

const AnswerPageRoute = () => {
    const navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }

    return (
        <Routes>
            <Route path="/*" element={<AnswerSentimentAndKeyword />} />
        </Routes>
    )
}

export const AnswerRoutes = () => {
    const navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }
    return (
        <Fade in={true} timeout={500}>
            <Box component="div">
                <AppBar />
                <Container maxWidth="xl">
                    <Box component="div" sx={{ paddingTop: "40px", paddingBottom: "32px" }}>
                        <Routes>
                            <Route path="/" element={<ViewAnswersPage onBack={goBack} />} />
                            <Route path="/:id/*" element={<AnswerPageRoute />} />
                        </Routes>

                    </Box>
                </Container>
            </Box>
        </Fade>
    )
}